"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'app-workspaces/v1/workspaces';

var WorkspacesAPI =
/*#__PURE__*/
function () {
  function WorkspacesAPI() {
    (0, _classCallCheck2.default)(this, WorkspacesAPI);
  }

  (0, _createClass2.default)(WorkspacesAPI, null, [{
    key: "createWorkspace",
    value: function createWorkspace(workspace) {
      return _apiClient.default.post(API_BASE, {
        data: workspace
      });
    }
  }, {
    key: "updateWorkspace",
    value: function updateWorkspace(workspace) {
      return _apiClient.default.put(API_BASE + "/" + workspace.id, {
        data: workspace
      });
    }
  }, {
    key: "deleteWorkspace",
    value: function deleteWorkspace(id) {
      return _apiClient.default.delete(API_BASE + "/" + id);
    }
  }, {
    key: "deleteWorkspaceMembers",
    value: function deleteWorkspaceMembers(id, userIds, teamIds) {
      var request = {
        workspaceId: id,
        userMemberIds: userIds,
        teamMemberIds: teamIds
      };
      return _apiClient.default.put(API_BASE + "/" + id + "/members/delete", {
        data: request
      });
    }
  }, {
    key: "addWorkspaceMembers",
    value: function addWorkspaceMembers(id, userIds, teamIds) {
      var request = {
        workspaceId: id,
        userMemberIds: userIds,
        teamMemberIds: teamIds
      };
      return _apiClient.default.put(API_BASE + "/" + id + "/members/add", {
        data: request
      });
    }
  }]);
  return WorkspacesAPI;
}();

exports.default = WorkspacesAPI;
module.exports = exports.default;